import { PipeTransform, Pipe } from '@angular/core';
import { User } from '../models/user.model';
import { pipe } from 'rxjs';

@Pipe({
    name: 'userFilter'
})

export class UserFilterPipe implements PipeTransform{
    transform(ListUsuarios:User[], searchTerm:string){
        if(!ListUsuarios || !searchTerm || +searchTerm==0){
            return ListUsuarios;
        }
      if (+searchTerm) {
        return ListUsuarios.filter(Usuario => Usuario.fkUserState == +searchTerm);
        }
      return ListUsuarios.filter(Usuario =>
        Usuario.userName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }
}
